import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'

import { Container, ContainerDataStore } from '@skinsoft/entity/src/container'
import { Item } from '@skinsoft/entity/src/item'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { ItemCard } from '@skinsoft/ui'
import { identity } from 'rxjs'
import { mergeAll, switchMap, toArray } from 'rxjs/operators'
import Component from 'vue-class-component'
import { MovementItemCard } from '../movement-item-card'
import { MOVEMENT_ITEM_CARD_LOCATION_CHANGED, UPDATE_ITEM_MOVEMENT_PAGE } from '@skinsoft/events'

require('./container-card.scss')

@Component({
    components: {
        sMovementItemCard: MovementItemCard,
        sItemCard: ItemCard,
    },
    props: ['container', 'inMovementDisplay', 'displayType'],
    template: require('./container-card.html'),
})
export class ContainerCard extends ReactiveVue {
    private container: Container

    private subItems: Item[] = []

    private inMovementDisplay: boolean
    private displayType: boolean

    private $containerDataStore: ContainerDataStore

    private closedContainerIcon = faLock
    private openedContainerIcon = faLockOpen

    private MOVEMENT_ITEM_CARD_LOCATION_CHANGED = MOVEMENT_ITEM_CARD_LOCATION_CHANGED
    private UPDATE_ITEM_MOVEMENT_PAGE = UPDATE_ITEM_MOVEMENT_PAGE

    private mounted() {
        this.$containerDataStore
            .getAssociatedItems(this.container.id)
            .pipe(
                switchMap(identity), // extract inner list from Observable
                mergeAll(),
                toArray(),
            )
            .subscribe(items => (this.subItems = items))
    }

    private get containerIcon() {
        if (this.container.containerItemSchema.openContainer) {
            return this.openedContainerIcon
        }

        if (this.container.containerItemSchema.openContainer === false) {
            return this.closedContainerIcon
        }
    }
}
